import * as _ from 'lodash-es'

import { ADD_ALERT, EXPIRE_ALERTS, HIDE_ALERTS, REMOVE_ALERT } from '../common/constants/reduxConstants'

export const addAlert = (alertObj: any) => {
  return {
    type: ADD_ALERT,
    payload: Object.assign({}, alertObj, { id: alertObj.id ?? _.uniqueId('alert_') }),
  }
}

export const removeAlert = (alertID: any) => {
  return {
    type: REMOVE_ALERT,
    payload: alertID,
  }
}

export const hideAlerts = () => {
  return {
    type: HIDE_ALERTS,
  }
}

export const expireAlerts = () => {
  return {
    type: EXPIRE_ALERTS,
  }
}
